import React, { forwardRef, useEffect, useRef, useState } from 'react'
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton, InputLabel, List, ListItem, MenuItem, Select, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material'
import '../../../../assets/ExtraStyle.css'
import { CancelOutlined, Info } from '@mui/icons-material';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ApiCopyTemplateQuestionCategory, ApiDeleteCatgory, ApiDeleteChecklistTemplateQuestion, ApiGetChecklistCategoryList, ApiGetChecklistTemplateQuestions, ApiUpdateTempQuestionData, RemoveTemplateQuestions, UpdateVenueQuestionOrder } from '../../../../apiService/Core/Apicall.tsx';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from 'react-redux';
import edit from '../../../../assets/images/editIcon.png'
import ChecklistQuestionList from '../ChecklistQuestionLists/ChecklistQuestionList.tsx';


interface DragItem {
    index: number;
}
const QuestionCard = forwardRef(({ question, index, moveQuestion, removequestion, updatequestion, setmaxScore, editId, maxScore, setEditId, setEditWeighted, editWeighted, colorHex, setcolorHex, setquestionGroup, setquestionLabel, questionGroup, questionLabel, checklistTemplateId }: { question: any; editId: string | null; colorHex: string | number | undefined; questionGroup: string | undefined, questionLabel: string | undefined; index: number; moveQuestion: (from: number, to: number) => void; removequestion: (id: number) => void; setEditId: (id: string | null) => void; setEditWeighted: (weight: number | string) => void; setmaxScore: (score: number | string) => void; setcolorHex: (colorHex: number | string) => void; setquestionGroup: (questionGroup: string) => void; setquestionLabel: (questionLabel: string) => void; editWeighted: any; maxScore: any; updatequestion: (id: number) => void; checklistTemplateId: any; }, ref) => {
    const dragRef = useRef<any>(null);
    const dropRef = useRef<any>(null);
    const DISABLE_DND = true;
    const [openQuestionUsage, setOpenQuestionUsage] = useState<boolean>(false)
    const [questionUsageList, setQuestionUsageList] = useState<any>([])
    const navigate = useNavigate()

    const [, drag] = useDrag({
        type: 'QUESTION',
        item: { index },
    });

    const [, drop] = useDrop({
        accept: 'QUESTION',
        hover: (draggedItem: DragItem) => {
            if (draggedItem.index !== index) {
                moveQuestion(draggedItem.index, index);
                draggedItem.index = index;
            }
        },
    });

    if (!DISABLE_DND) {
        drag(dragRef);
        drop(dropRef);
    }
    function decodeHtml(html: any) {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }

    return (
        <Box ref={(node) => {
            dragRef.current = node;
            dropRef.current = node;
        }} key={index} className='my-2' border='1px solid #E0E0E0' borderRadius='5px' padding='10px'>
            <Box>

                <Box className='w-100 d-flex justify-content-end'>
                    <Typography variant='caption' className='text-end'>Index: {index + 1}</Typography>
                </Box>
                <Box className='d-flex align-items-center justify-content-between my-3'>
                    <Box className='d-flex align-items-center' gap={1}>
                        <Typography className='text-main fw-bold'>Question ID: #{question.checklistQuestionId}</Typography>
                        {/* <Typography className='text-main fw-bold'>|</Typography> */}
                        {/* <Typography className='fw-bold'>Category: {?.categoryName}</Typography> */}
                        <Typography className='fw-bold'>|</Typography>
                        <Typography className='fw-bold'>Type: {question.qType?.length > 0 ? question.qType === "R" ? "Radio" : question.qType === "r" ? 'Radio Rating' : question.qType === "C" ? 'CheckBox' : "Text" : 'notFound'}</Typography>
                    </Box>
                    <Box className='d-flex align-items-center' gap={1}>
                        {/* <IconButton className='px-4 py-1 transform text-light' onClick={() => {
                        navigate(`/admin/create-new-question`, {
                            state: { questionData: question, checklistTemplateId: checklistTemplateId },
                        });
                    }}><img src={edit} height='25px'></img></IconButton> */}
                        {/* <Link
                            to={`/admin/checklist/create-new-question/${checklistTemplateId}/${question?.checklistTemplateQuestionId}`}
                            className='px-4 py-1 transform text-light'

                        ><img src={edit} height='25px'></img></Link> */}
                        <Link
                            // className="col-4"
                            className='px-4 py-1 transform text-light'
                            style={{ cursor: 'pointer' }}
                            to={`/admin/checklist/create-new-question/${question?.checklistQuestionId}`}
                        >
                            <Box component="img" src={edit} className="w-100" minWidth={'10px'} maxWidth={'25px'}></Box>
                        </Link>
                        <Button className='px-4 py-1 bg-danger transform text-light' onClick={() => { removequestion(question.checklistTemplateQuestionId) }}>- Remove</Button>
                        {/* {editId === question.questionId && <Button className='px-3 py-1 bg-grey transform text-light' onClick={() => { updatequestion(question.checklistTemplateQuestionId) }}>Save</Button>} */}
                    </Box>
                </Box>
                <Box>
                    <Typography className='fw-bold my-1 d-flex'>Q:&nbsp;<span dangerouslySetInnerHTML={{ __html: question.question }} /></Typography>
                    <Box className='d-flex align-items-center' gap={3}>
                        <Box className='d-flex align-items-center'>
                            {/* <Box className='px-4 py-1 text-main' borderRight='1px solid #747247' bgcolor='#7472471A'>
                            <Typography>Ver {question.verNo}</Typography>
                        </Box> */}
                            {/* <Typography className='px-4 my-2 py-1 text-main bg-light-primary'>{question.entityTypeId?.entityTypeName || 'undefined'}</Typography> */}
                        </Box>
                        {question.isPhotoRequire && (
                            <Box className=" bg-light-primary px-4 py-2" borderRadius='20px' width='fit-content'>
                                <Typography>Images - Min: {question.minPhoto}</Typography>
                            </Box>
                        )}
                    </Box>
                    {question.qOptionJson !== null && question.qOptionJson !== "" ? (
                        <List component='ol' className="question-options w-100 d-flex justify-content-between flex-wrap">
                            {(() => {
                                try {
                                    return question.qOptionJson.map((option: any, index: number) => (
                                        <ListItem key={index} className="col-6 option-text">
                                            <span>{index + 1}. &nbsp;</span>
                                            <span dangerouslySetInnerHTML={{ __html: option.value }} /> &nbsp;
                                            <span>(<span dangerouslySetInnerHTML={{ __html: option.optionScore }} />)</span>
                                            {option.radioRatingComment && (
                                                <span className="ml-1">({option.radioRatingComment})</span>
                                            )}
                                            <Tooltip
                                                title={
                                                    <Box>
                                                        <Typography variant='caption' display={'block'}><b>optionComment: </b> {option?.optionComment}</Typography>
                                                        <Typography variant='caption' display={'block'}><b>minChar: </b> {option?.minChar}</Typography>
                                                        <Typography variant='caption' display={'block'}><b>optionCommentType: </b> {option?.optionCommentType ?? "N/A"}</Typography>
                                                        {option?.optionImage && (<Typography variant='caption' display={'block'}><b>optionImage: </b> {option?.optionImage}</Typography>)}
                                                    </Box>
                                                }
                                            >
                                                <Info sx={{ fontSize: '16px', marginLeft: "8px" }} />
                                            </Tooltip>
                                        </ListItem>
                                    ));
                                } catch (error) {
                                    console.error("Invalid JSON in qOptionJson:", error);
                                    return (
                                        <Typography className="option-text text-danger">
                                            Error: Invalid JSON format
                                        </Typography>
                                    );
                                }
                            })()}
                        </List>
                    ) : (
                        <Typography className="option-text">
                            Answer will be a manual Text Entry
                        </Typography>
                    )}
                </Box>
                <Typography className="d-flex">
                    Description: &nbsp;<span dangerouslySetInnerHTML={{ __html: decodeHtml(question.questionDescription) }} />
                </Typography>
                <Typography className="d-flex">
                    Hint: &nbsp;<span dangerouslySetInnerHTML={{ __html: decodeHtml(question.questionHint) }} />
                </Typography>
            </Box>
            <Dialog fullWidth open={openQuestionUsage}>
                <Box className='d-flex align-items-center justify-content-between p-3'>
                    <Typography className="fw-bold" variant="h5">Question Usage</Typography>
                    <IconButton onClick={() => { setOpenQuestionUsage(false); setQuestionUsageList([]); }}>
                        <CancelOutlined />
                    </IconButton>
                </Box>
                <Box className='p-3'>
                    {questionUsageList?.businessUsage?.length > 0 && (
                        <Box className='mb-3'>
                            <Typography variant="h6">Businesses</Typography>
                            <List sx={{ listStyleType: "disc", pl: 4 }}>
                                {
                                    questionUsageList?.businessUsage?.map((item: any, index: number) => (
                                        <ListItem key={index}
                                            className="px-0"
                                            sx={{ display: "list-item !important", listStyle: 'outside', py: 0 }}>
                                            <Link
                                                to={`/admin/create-client-template/${item?.clientEntityId}`}
                                                // className="table-row-background fs-14 link-btn"
                                                style={{ textDecoration: "underline !important", color: "#75724C" }}
                                                target="__blank"
                                            > {item?.entityName}
                                            </Link>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    )}

                    {questionUsageList?.venueUsage?.length > 0 && (
                        <Box className='mb-3'>
                            <Typography variant="h6">Sites</Typography>
                            <List component="ul" sx={{ listStyleType: "disc", pl: 4 }}>
                                {
                                    questionUsageList?.venueUsage?.map((item: any, index: number) => (
                                        <ListItem key={index}
                                            className="px-0"
                                            sx={{ display: "list-item", listStyle: 'outside', py: 0 }}>
                                            <Link
                                                to={`/admin/create-venue-site-template/${item?.venueId}`}
                                                // onClick={() => navigateToVenueSiteQuestion(venue)}
                                                style={{ textDecoration: "underline !important", color: "#75724C" }}
                                                target="__blank"
                                            >
                                                {item?.venueName}
                                            </Link>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    )}
                    {questionUsageList?.templateUsage?.length > 0 && (
                        <Box className='mb-3'>
                            <Typography variant="h6">Question Template</Typography>
                            <List component="ul" sx={{ listStyleType: "disc", pl: 4 }}>
                                {
                                    questionUsageList?.templateUsage?.map((item: any, index: number) => (
                                        <ListItem key={index}
                                            className="px-0"
                                            sx={{ display: "list-item", listStyle: 'outside', py: 0 }}>
                                            <Link to={`/admin/create-new-template/${item?.templateName}/${item?.checklistTemplateId}`}
                                                style={{ textDecoration: "underline !important", color: "#75724C" }}
                                                target="__blank"

                                            >
                                                {item?.templateName}</Link>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    )}
                </Box>
            </Dialog>
        </Box>


    );
});

function CreateTemplateQuestions() {

    const dispatch = useDispatch()
    const [category, setcategorey] = useState<any>([])
    const [activequestions, setactivequestions] = useState<any>([])
    const [selectedCategory, setselectedCategory] = useState<number | string>('')
    const [TemplateQuestions, setTemplateQuestions] = useState<any>([])
    // const [addedFilters, setAddedFilters] = useState<number[]>([]);
    const [alignment, setAlignment] = useState<number>(TemplateQuestions && TemplateQuestions[0]?.checklistCategoryId);
    const [reload, setreload] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<number>(0);
    const [ischange, setischange] = useState<boolean>(false);
    const [editId, setEditId] = useState<string | null>(null);
    const [editWeighted, setEditWeighted] = useState<string | number>();
    const [editColorHex, setEditcolorHex] = useState<string | number>();
    const [questionGroup, setquestionGroup] = useState<string>('');
    const [questionLabel, setquestionLabel] = useState<string>('');
    const [maxScore, setmaxScore] = useState<string | number>();
    const [categoryName, setCategoryName] = useState<any>(null)
    const [open, setOpen] = useState(false);
    const [newCategoryId, setNewCategoryId] = useState<any>(null);
    const { templateName, checklistTemplateId }: any = useParams()
    const [openOrderDialog, setOpenOrderDialog] = useState(false);
    const [questionOrders, setQuestionOrders] = useState<any[]>([]);



    const handleQuestionListUpdate = () => {
        setRefresh((prev) => prev + 1);
    };
    const moveQuestion = (fromIndex: number, toIndex: number) => {
        const updatedQuestions = [...activequestions];
        const [movedQuestion] = updatedQuestions.splice(fromIndex, 1);
        updatedQuestions.splice(toIndex, 0, movedQuestion);
        setactivequestions(updatedQuestions);
        setischange(!ischange)
    };

    useEffect(() => {
        if (category.length > 0) {
            setselectedCategory(category[category.length - 1]?.checklistCategoryId);
        }
    }, [selectedCategory, category]);


    useEffect(() => {
        const fetchcategory = async () => {
            try {
                const data = `?isActive=true`
                const categories = await ApiGetChecklistCategoryList(data)
                setcategorey(categories.data)
            }
            catch (error: any) {
                toast.error(error?.message)
            }

        }

        fetchcategory()
    }, [])

    // const fetchtselectedquestions = async () => {
    //     setTemplateQuestions([])
    //     try {
    //         const data = `?offset=0&limit=100&checklistTemplateId=${checklistTemplateId}`
    //         const response = await ApiGetChecklistTemplateQuestions(data)
    //         setreload(false)
    //         setTemplateQuestions(response?.data?.categories)
    //         setAlignment(response?.data?.categories?.[0]?.checklistCategoryId)
    //         // setAddedFilters(response?.data?.categories)
    //     }
    //     catch (error: any) {
    //         toast.error(error.message)
    //     }

    // }

    // useEffect(() => {
    //     fetchtselectedquestions()
    // }, [refresh])

    const fetchtselectedquestions = async () => {
        setTemplateQuestions([]);

        try {
            const data = `?offset=0&limit=100&checklistTemplateId=${checklistTemplateId}`;
            const response = await ApiGetChecklistTemplateQuestions(data);

            let categories = [...(response?.data?.categories || [])];

            // If categoryDisplayOrder exists, sort by it
            if (response?.data?.categoryDisplayOrder) {
                console.log('Call Sorting oRder')
                const order = response?.data?.categoryDisplayOrder
                    .split(",")
                    .map((id: string) => Number(id.trim()));

                categories.sort(
                    (a: any, b: any) =>
                        order.indexOf(a.checklistCategoryId) -
                        order.indexOf(b.checklistCategoryId)
                );
            } else {
                // Otherwise sort by question displayOrder
                    console.log('Call UnSorting oRder')
                categories.sort(
                    (a: any, b: any) =>
                        (a.questions?.[0]?.displayOrder ?? 0) -
                        (b.questions?.[0]?.displayOrder ?? 0)
                );
            }
            console.log("Categories", categories)
            setTemplateQuestions(categories);
            setAlignment(categories?.[0]?.checklistCategoryId);
        } catch (error: any) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        fetchtselectedquestions();
    }, [refresh]);

    // const handleChange2 = (event:any) => {
    //     setAddedFilters(prevFilters =>
    //         prevFilters.includes(event)
    //             ? prevFilters
    //             : [...prevFilters, event]
    //     );
    // };

    const handleAlignment = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: number,
    ) => {
        setAlignment(newAlignment);
    };

    const removequestion = async (checklistTemplateQuestionId: number) => {
        const isConfim = window.confirm("Are you sure you want to delet this question ?");
        if (!isConfim) return;
        try {
            const data = `?checklistTemplateQuestionId=${checklistTemplateQuestionId}`
            const response = await ApiDeleteChecklistTemplateQuestion(data)
            toast.success(response.message)
            fetchtselectedquestions()
        }
        catch (error: any) {
            toast.error(error?.message)
        }

    }

    useEffect(() => {
        if (TemplateQuestions) {
            const activeCategory = TemplateQuestions.find((q: any) => q?.checklistCategoryId == alignment)
            setactivequestions(activeCategory?.questions);
        }
    }, [alignment, TemplateQuestions]);


    const updatequestion = async (checklistTemplateQuestionId: any) => {
        const data = `?checklistTemplateQuestionId=${checklistTemplateQuestionId}`
        const data1 = {
            ...(editWeighted && { questionWeightage: Number(editWeighted) }),
            ...(maxScore && { maxScore: Number(maxScore) }),
            ...(editColorHex && { colorHex: editColorHex }),
        }
        try {
            const response = await ApiUpdateTempQuestionData(data, data1)
            localStorage.setItem('alignment', alignment.toString())
            toast.success(response.message)
            setEditId(null)
        }
        catch (error: any) {
            toast.error(error)
        }

    }

    const handleCloseDialog = () => {
        setOpen(false);
        setNewCategoryId(null)
    };

    const handleCopyQuestion = async () => {
        const questionIds = activequestions.map((q: any) => q.questionId.questionId) || [];
        if (!newCategoryId) {
            toast.error("Please Select Category To Replace.");
            return
        }
        if (!alignment) {
            toast.error("Please Select Category");
            return;
        }
        try {
            const data = {
                newCategoryId: newCategoryId,
                checklistTemplateId: checklistTemplateId,
                oldCategoryId: alignment,
                questions: questionIds
            }
            const res = await ApiCopyTemplateQuestionCategory(data);
            toast.success(res.message);
            setOpen(false);
            fetchtselectedquestions();
        } catch (error: any) {
            console.error("Error Copying Question", error);
            toast.error(error)
        }
    }

    const handleDeleteCategory = async (id: any) => {
        try {
            const data = {
                type: "template_questions",
                checklistTemplateId: checklistTemplateId,
                categoryDisplayOrderId: id
            }
            const res = await ApiDeleteCatgory(data);
            if (res.status) {
                fetchtselectedquestions();
                toast.success(res.message)
            }
        } catch (error: any) {
            console.error("Error Deleting Category:", error)
            toast.error(error);
        }
    }

    return (
        <Box className='container-fluid bg-light create-new-template extra' boxShadow='0px 0px 3px #000000' minHeight='calc(100vh - 165px)' padding='30px 20px 20px 20px '>
            <Box className="d-flex my-2 justify-content-between align-items-center">
                <Typography className='m-0 p-0' variant='subtitle1'>{/*{templateData?.checklistTemplateId || 0} &nbsp;*/}{templateName || "Undefine"}</Typography>
            </Box>
            <Divider className='my-3' />
            <Box className='d-flex align-items-center justify-content-end my-1 mb-3'>
                <Link
                    to={`/admin/change-checklist-template-question-order/${templateName}/${checklistTemplateId}`}
                    className='bg-grey text-light link-btn whitespace px-3 py-2'
                >
                    Change Order
                </Link>
            </Box>
            <Box className='d-flex' gap={2}>
                <Box className='w-50 p-2' border='1px solid #E0E0E0'>
                    <ChecklistQuestionList onUpdate={handleQuestionListUpdate}
                        checklistTemplateId={checklistTemplateId} />
                </Box>
                <Box className='w-50 p-2' border='1px solid #E0E0E0'>
                    <Typography className='fs-18 fw-bold mb-2 mt-1'>{templateName} Finalised Questions</Typography>
                    <Box className='d-flex align-items-stretch'>
                        {/* <FormControl className='col-2'>
                            <Select value={selectedCategory ?? ''} renderValue={() => "Select Category"} onChange={(e) => { setselectedCategory(Number(e.target.value)); handleChange2(e.target.value) }}>

                                {category.length > 0 &&
                                    category.map((cat:any, index:number) => (
                                        <MenuItem value={cat?.checklistCategoryId} key={index}>
                                            {cat.categoryName}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl> */}
                        <ToggleButtonGroup
                            sx={{ overflow: 'auto' }}
                            color="primary"
                            value={alignment}
                            exclusive
                            onChange={handleAlignment}
                            aria-label="Platform"
                        >
                            {TemplateQuestions?.map((filter: any, index: number) => {
                                // const matchedCategory = category.find((cat:any) => cat?.categoryId === filter);
                                // const categoryName = matchedCategory ? matchedCategory.categoryName : "Unknown";
                                return (
                                    <ToggleButton
                                        className="transform d-flex align-items-center"
                                        sx={{ gap: 2, fontSize: '16px', whiteSpace: 'nowrap' }}
                                        key={index}
                                        value={filter?.checklistCategoryId}
                                    >
                                        {filter?.categoryName}
                                        {/* <span
                                            className='d-flex align-items-center'
                                            onClick={() => {
                                                const isConfirm = window.confirm("Are you sure you want to delete this category with question ?")
                                                if (isConfirm) {
                                                    handleDeleteCategory(filter)
                                                }
                                            }
                                            }
                                        >
                                            <CancelOutlined sx={{ fontSize: '18px' }} />
                                        </span> */}
                                    </ToggleButton>
                                )
                            })}
                        </ToggleButtonGroup>

                    </Box>
                    {/* {TemplateQuestions?.length > 0 && TemplateQuestions.map((question, index) => (
                         alignment === question.categoryId?.categoryId && (
                        
                    )))} */}
                    <DndProvider backend={HTML5Backend}>
                        {/* {TemplateQuestions?.length > 0 && TemplateQuestions.map((question, index) => (
                            alignment === question.categoryId?.categoryId && (

                                <QuestionCard key={index} removequestion={removequestion} question={question} index={index} moveQuestion={moveQuestion} />
                            )))} */}
                        {
                            activequestions?.length > 0 && activequestions.map((question: any, index: number) => (
                                <QuestionCard key={index} removequestion={removequestion} question={question} index={index} moveQuestion={moveQuestion} colorHex={editColorHex} questionGroup={questionGroup} questionLabel={questionLabel} setquestionLabel={setquestionLabel} setquestionGroup={setquestionGroup} setcolorHex={setEditcolorHex} setEditId={setEditId} editWeighted={editWeighted} setEditWeighted={setEditWeighted} maxScore={maxScore} setmaxScore={setmaxScore} editId={editId} updatequestion={updatequestion} checklistTemplateId={checklistTemplateId} />
                            ))
                        }
                    </DndProvider>


                </Box>
            </Box>

            <Dialog
                open={open}
                onClose={handleCloseDialog}
                maxWidth={false}
                PaperProps={{
                    sx: {
                        width: "400px",
                        height: "400px",
                        maxWidth: "none",
                    },
                }}
            >
                <DialogTitle>
                    Select New Category
                </DialogTitle>

                <DialogContent>
                    <Box sx={{ mt: 2 }}>
                        <Autocomplete
                            disablePortal
                            id="mm-autocomplete"
                            options={category}
                            getOptionLabel={(option: any) => `${option?.categoryName}`}
                            value={category.find((option: any) => option?.checklistCategoryId === newCategoryId) || null}
                            onChange={(event, newValue) => {
                                setNewCategoryId(newValue?.checklistCategoryId)
                                setCategoryName(newValue?.categoryName)
                            }}
                            defaultValue=""
                            renderInput={(params) => <TextField {...params} label="Select Category" />}
                            size="small"
                        />
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseDialog} sx={{ color: "#ADB792", borderColor: "#ADB792", }} variant='outlined'>
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            const alignedCategory = category.find(
                                (cat: any) => cat?.categoryId === alignment
                            );

                            const alignedCategoryName = alignedCategory?.categoryName || "";
                            const isConfirm = window.confirm(`Are you sure you want to update ${alignedCategoryName} category to ${categoryName} category?`)
                            if (isConfirm) {
                                handleCopyQuestion()
                            }
                        }}
                        variant="contained"
                        className='table-row-background'
                    >
                        Update
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    )
}

export default CreateTemplateQuestions
